export default "__VITE_ASSET__8f76a596__"